import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map, startWith } from 'rxjs/operators';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { BasicWithLibelleModel } from 'src/app/shared/models/basic/basicWithLibelle.model';
import * as util from '../../../constants/util';

@Component({
  selector: 'app-table-field-autocomplete',
  templateUrl: './table-field-autocomplete.component.html',
  styleUrls: ['./table-field-autocomplete.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TableFieldAutocompleteComponent implements OnChanges {

  @Input() objets: BasicWithLibelleModel[];
  @Input() required: boolean;
  @Input() parentForm: UntypedFormGroup;
  @Input() codeControlName: string;
  @Input() libelleControlName: string;
  @Input() placeholder: string;
  @Output() objetChange = new EventEmitter<BasicWithLibelleModel>();
  @ViewChild('matInput') matInput: ElementRef<HTMLInputElement>;

  public util = util;
  objetsString: string[] = [];
  filteredObjets: Observable<string[]>;
  myControl = new UntypedFormControl();

  ca1Selected: any = null;
  @Output() ca1ChildEmit = new EventEmitter<any>();
  @Input() fieldType: string;
  libelleControl: AbstractControl;
  codeControl: AbstractControl;
  itemSelected: any;
  @Output() changeEvent = new EventEmitter<any>();

  constructor() {
  }

  reLoadObjets(): void {
    this.objetsString = [];
    if (this.objets !== undefined) {
      this.objets = [...new Map(this.objets.map(item =>[ item['code'] + '-' + item['libelle'], item])).values()];
      for (const objet of this.objets) {
        this.objetsString.push(objet.code + '-' + objet.libelle);
      }
      this.objetsString.sort((a, b) => a.localeCompare(b));
      this.filteredObjets = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.objetsString.slice(0, 30)));
    }
  }
  setValidators(): void {
    if (this.objets && this.objets.length > 0) {
      this.myControl.enable();
      const validators = [];
      validators.push(forbiddenNamesValidator(this.objets));
      if (util.hasRequiredField(this.codeControl)) {
        validators.push(Validators.required);
      }
      this.myControl.setValidators(validators);
    } else {
      this.myControl.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.parentForm && this.codeControlName && this.libelleControlName) {
      this.reLoadObjets();
      this.setValidators();
      this.codeControl = this.parentForm.get(this.codeControlName);
      this.libelleControl = this.parentForm.get(this.libelleControlName);
      if (this.codeControl && this.libelleControl) {
        this.parentForm.setControl(this.codeControlName + this.libelleControlName, this.myControl);
        if (this.codeControl.value && this.libelleControl.value) {
          this.myControl.setValue(this.codeControl.value + '-' + this.libelleControl.value);
        }
        combineLatest([this.codeControl.valueChanges, this.libelleControl.valueChanges])
          .pipe(filter(([code, libelle]) => code && libelle))
          .subscribe(([code, libelle]) => {
            if (code && libelle) {
              this.myControl.setValue(code + '-' + libelle);
            } else if (!code && !libelle) {
              this.myControl.setValue('');
            }
            this.setValidators();
        });
      }
    }
  }

  onObjetChange(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    const objet = this.objets.find(obj => obj.code + '-' + obj.libelle === value);
    if (objet) {
      this.codeControl.setValue(objet.code);
      this.libelleControl.setValue(objet.libelle);
    }
    this.reLoadObjets();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const objSelected = this.objetsString.find(obj => obj.toLowerCase() === filterValue);
    if (objSelected){
      return this.objetsString.slice(0, 30);
    } else {
      return this.objetsString.filter(obj => obj.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
    }
  }

  deleteIfEmpty(): void {
    this.libelleControl.setValue('');
    this.codeControl.setValue('');
  }

}


export function forbiddenNamesValidator(names: BasicWithLibelleModel[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value && names) {
      const index = names.findIndex(name => {
        return (name.code + '-' + name.libelle).localeCompare(control.value) === 0;
      });
      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    } else {
      return null;
    }
  };
}
